(function () {
  var nav = document.getElementById('ppFloatNav');
  if (!nav) return;

  /* ---------- show / hide on scroll ----------
     TWO things used to break this, and both had to be fixed:

     1. The element was captured once into `nav`. Adding to cart makes Shopify
        re-render the header sections, which REPLACES this node - after that
        every class toggle landed on a detached element that is no longer on
        the page. Hence "only a refresh brings the icons back". So the node is
        re-resolved on every pass and the stale reference is never trusted.

     2. The wanted state was compared against a cached boolean, so if anything
        stripped .is-on the flag still claimed "shown" and every later scroll
        matched it. State is now read back off the DOM instead. */
  var SHOW_AT = 90, ticking = false;

  function el() {
    if (!nav || !nav.isConnected) nav = document.getElementById('ppFloatNav');
    return nav;
  }

  function apply() {
    ticking = false;
    var n = el();
    if (!n) return;
    var should = window.scrollY > SHOW_AT;
    /* only write when the state actually changes: the unconditional toggle
       invalidated style on every call, and the next scrollY read then forced
       a synchronous layout - Lighthouse traced ~130ms of forced reflow on a
       product page to exactly this line */
    if (document.body.classList.contains('pp-floatnav-on') !== should) {
      document.body.classList.toggle('pp-floatnav-on', should);
    }
    if (n.classList.contains('is-on') === should) return;
    n.classList.toggle('is-on', should);
    n.setAttribute('aria-hidden', should ? 'false' : 'true');
    /* inert tracks aria-hidden so hidden buttons can't take keyboard focus */
    if (should) n.removeAttribute('inert');
    else n.setAttribute('inert', '');
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(apply); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  /* bfcache restore re-shows the old DOM without re-running this script */
  window.addEventListener('pageshow', apply);
  document.addEventListener('shopify:section:load', apply);
  /* A replaced node arrives with no event of its own, so watch for it - but
     only inside the nav's own host. Watching document.body with subtree:true
     ran a scrollY read plus a body class write on EVERY node inserted anywhere
     on the page, which on this template means the whole Judge.me review stream.
     The 1s poll that sat here on top of that is gone too: scroll, resize,
     pageshow and shopify:section:load already cover every real case. */
  var navHost = (nav && nav.parentNode) || document.body;
  /* coalesced through the same rAF gate as scroll, so a burst of insertions
     (apps mounting into the host) costs one layout read, not one per node */
  new MutationObserver(onScroll)
    .observe(navHost, { childList: true });
  apply();

  /* ---------- forward clicks to the real header controls ----------
     The real controls live at the TOP of the page, and .click() focuses
     them - the browser then scrolls the focused element into view, which
     is the "jumps back to the top" bug. Scroll position is pinned around
     the forwarded click, and again when the drawer closes and Dawn hands
     focus back to the header. */
  var savedY = 0;

  /* THE actual cause of the jump: Dawn calls .focus() on the header cart icon
     and the menu summary when a drawer opens AND when it closes. A plain
     .focus() scrolls the focused element into view, and those controls live
     at the top of the page. Patching their focus() to always pass
     {preventScroll:true} kills it at the source, for open and close, instead
     of racing it with scrollTo afterwards. */
  function patchFocus(el) {
    if (!el || el.__ppNoScrollFocus) return;
    try {
      var native = el.focus.bind(el);
      el.focus = function (opts) {
        try {
          var o = { preventScroll: true };
          if (opts) for (var k in opts) o[k] = opts[k];
          native(o);
        } catch (e) { try { native(); } catch (_) {} }
      };
      el.__ppNoScrollFocus = true;
    } catch (e) {}
  }
  function patchAll() {
    /* NOT header-drawer summary: Dawn's own click handler runs off that
       element and patching it interfered with the drawer opening at all.
       The summary does not need it anyway - the drawer traps focus into
       its own contents, and pinScroll already holds the position. */
    [
      '#cart-icon-bubble',
      'a.header__icon--cart',
      '.menu-drawer__close-button',
      'cart-drawer .drawer__close'
    ].forEach(function (sel) {
      try { document.querySelectorAll(sel).forEach(patchFocus); } catch (e) {}
    });
  }
  patchAll();
  document.addEventListener('shopify:section:load', patchAll);

  function pinScroll() {
    savedY = window.scrollY;
    patchAll();
    requestAnimationFrame(function () { window.scrollTo(0, savedY); });
    setTimeout(function () { window.scrollTo(0, savedY); }, 60);
  }
  function restoreScroll() {
    requestAnimationFrame(function () { window.scrollTo(0, savedY); });
    setTimeout(function () { window.scrollTo(0, savedY); }, 60);
    setTimeout(function () { window.scrollTo(0, savedY); }, 220);
  }

  function openMenu() {
    var summary = document.querySelector('header-drawer summary.header__icon--menu')
               || document.querySelector('header-drawer summary');
    if (summary) { pinScroll(); summary.click(); return true; }
    return false;
  }
  function openCart() {
    var icon = document.querySelector('#cart-icon-bubble, a.header__icon--cart');
    if (icon) { pinScroll(); icon.click(); return true; }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { pinScroll(); drawer.open(); return true; }
    window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    return true;
  }

  /* Track whether ANY drawer is open. This drives body.pp-drawer-open, which
     is what stops the sticky-header hiding from making the drawer invisible.
     Also restores scroll on close, since Dawn re-focuses the header there. */
  function anyDrawerOpen() {
    var det = document.querySelector('header-drawer details');
    if (det && det.hasAttribute('open')) return true;
    var cd = document.querySelector('cart-drawer');
    if (cd && (cd.classList.contains('active') || cd.classList.contains('animate'))) return true;
    return false;
  }
  var wasOpen = false;
  function syncDrawerState() {
    var open = anyDrawerOpen();
    document.body.classList.toggle('pp-drawer-open', open);
    if (wasOpen && !open) restoreScroll();
    wasOpen = open;
  }

  function watchClose() {
    var det = document.querySelector('header-drawer details');
    if (det && !det.__ppWatched) {
      det.__ppWatched = true;
      new MutationObserver(syncDrawerState).observe(det, { attributes: true, attributeFilter: ['open'] });
    }
    var cd = document.querySelector('cart-drawer');
    if (cd && !cd.__ppWatched) {
      cd.__ppWatched = true;
      new MutationObserver(syncDrawerState).observe(cd, { attributes: true, attributeFilter: ['class'] });
    }
    syncDrawerState();
  }
  watchClose();
  document.addEventListener('shopify:section:load', watchClose);
  /* belt and braces: a drawer can also be closed by Escape or a backdrop tap */
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape') setTimeout(syncDrawerState, 30); });
  document.addEventListener('click', function () { setTimeout(syncDrawerState, 60); }, true);

  /* Delegated from document, not bound to the bar itself: a section re-render
     replaces the bar's node and would take any listener attached to it with
     it, leaving visible buttons that do nothing. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#ppFloatNav [data-pp-fn]');
    if (!btn) return;
    e.preventDefault();
    if (btn.dataset.ppFn === 'menu') openMenu(); else openCart();
  });

  /* ---------- mirror the header cart, count AND icon ----------
     Dawn re-renders the whole #cart-icon-bubble node on every cart change and
     swaps icon-cart-empty for the filled icon-cart, so watching that node
     directly breaks the moment it is replaced. We observe the header instead
     (a stable ancestor) and clone whatever icon is currently in there. Our own
     writes all land inside .pp-floatnav, which the header does not contain, so
     there is no feedback loop. */
  var cartBtn = nav.querySelector('[data-pp-fn="cart"]');
  var badge   = nav.querySelector('[data-pp-cart-count]');
  var lastN   = null;
  var lastSig = null;
  var mo      = null;

  function sync() {
    var bubble = document.querySelector('#cart-icon-bubble');

    // count: Dawn only prints .cart-count-bubble when the cart is non-empty
    var src = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]')
           || document.querySelector('.cart-count-bubble span[aria-hidden]');
    var n = src ? parseInt(src.textContent.trim(), 10) : 0;
    if (isNaN(n)) n = 0;
    if (n !== lastN) {
      lastN = n;
      badge.textContent = n > 99 ? '99+' : n;
      badge.hidden = n < 1;
    }

    // icon: clone the header's live svg so full/empty always matches
    var svg = bubble && bubble.querySelector('svg');
    if (!svg) return;
    var sig = svg.getAttribute('class') || '';
    if (sig === lastSig) return;
    lastSig = sig;

    var clone = svg.cloneNode(true);
    clone.removeAttribute('width');
    clone.removeAttribute('height');
    clone.setAttribute('aria-hidden', 'true');
    var old = cartBtn.querySelector('svg');
    if (old) cartBtn.replaceChild(clone, old);
    else cartBtn.insertBefore(clone, badge);
  }

  function watch() {
    var host = document.querySelector('.header') || document.body;
    if (mo) mo.disconnect();
    mo = new MutationObserver(sync);
    mo.observe(host, { childList: true, subtree: true, characterData: true });
  }

  sync();
  watch();
  // the header section itself can be swapped out; re-attach when that happens
  document.addEventListener('shopify:section:load', function () { watch(); sync(); });
  document.addEventListener('cart:refresh', sync);
  document.addEventListener('cart-drawer:updated', sync);
})();
